import pluralize from 'pluralize';

pluralize.addUncountableRule('wood');
pluralize.addUncountableRule('metal');
